/* structure-ui.js — Panneau explorateur de structure : arbre du conteneur
 * (nom, offset déc/hex, taille), anomalies, verdict « bien formé ».
 * Expose window.Structure : { setFile(file), reset(), reveal(offset), onResult(fn) }. */
(function () {
  'use strict';

  var F = window.MediaFormat;
  var worker = null, file = null, els = {};
  var listeners = [], pendingReveal = null;
  function $(id) { return document.getElementById(id); }

  function ensureWorker() {
    if (worker) return worker;
    worker = new Worker(new URL('./workers/structure.worker.js', import.meta.url), { type: 'module' });
    worker.onmessage = function (e) {
      var m = e.data || {};
      els.btn.disabled = false;
      if (m.type === 'structure') {
        renderResult(m.result);
        listeners.forEach(function (fn) { fn(m.result); });
        if (pendingReveal != null) { var o = pendingReveal; pendingReveal = null; reveal(o); }
      }
      else if (m.type === 'error') setStatus('Analyse de structure impossible : ' + m.error, true);
    };
    worker.onerror = function (ev) { els.btn.disabled = false; setStatus('Worker structure : ' + (ev.message || ''), true); };
    return worker;
  }

  function run() {
    if (!file) return;
    els.btn.disabled = true;
    els.tree.innerHTML = '';
    setStatus('Lecture de la structure…', false);
    ensureWorker().postMessage({ type: 'structure', file: file });
  }

  function setStatus(msg, isErr) { els.status.textContent = msg; els.status.className = 's-status' + (isErr ? ' err' : ''); }

  function renderResult(res) {
    if (!res.supported) {
      setStatus('Format de conteneur non pris en charge par l’explorateur (MP4/MOV, MKV/WebM, WAV/AVI).', false);
      return;
    }
    var v;
    if (res.truncated) v = '<span class="s-verdict warn">⚠ Structure incomplète — troncature probable</span>';
    else if (res.issues.length) v = '<span class="s-verdict warn">⚠ Anomalies structurelles détectées</span>';
    else v = '<span class="s-verdict ok">✓ Structure bien formée</span>';
    var meta = res.nodeCount + ' élément(s)' + (res.capped ? ' (limite atteinte, arbre tronqué à l’affichage)' : '');
    var issues = res.issues.length ? '<ul class="s-issues">' + res.issues.map(function (i) { return '<li>' + F.esc(i) + '</li>'; }).join('') + '</ul>' : '';
    setStatus('', false);
    els.tree.innerHTML = '<div class="s-head">' + v + ' <span class="s-meta">' + F.esc(meta) + '</span></div>' + issues + treeHtml(res.root);
  }

  // Ouvre l'arbre jusqu'à cet offset et y amène le focus.
  function reveal(offset) {
    var el = els.tree && els.tree.querySelector('[data-offset="' + offset + '"]');
    if (!el) {
      if (file && !els.btn.disabled) { pendingReveal = offset; run(); }
      els.panel.scrollIntoView({ block: 'start' });
      return;
    }
    for (var p = el.parentElement; p && p !== els.tree; p = p.parentElement) if (p.tagName === 'DETAILS') p.open = true;
    var target = el.tagName === 'DETAILS' ? el.querySelector('summary') : el;
    target.scrollIntoView({ block: 'center' });
    target.focus();
  }

  function nodeMeta(n) {
    return '<span class="s-off">@' + n.offset + ' · 0x' + n.offset.toString(16) + '</span>' +
      '<span class="s-size">' + n.size + ' o</span>' +
      (n.decoded ? '<span class="s-dec">' + F.esc(n.decoded) + '</span>' : '') +
      (n.anomaly ? '<span class="s-an">⚠ ' + F.esc(n.anomaly) + '</span>' : '');
  }
  function treeHtml(nodes) {
    if (!nodes || !nodes.length) return '';
    return '<div class="s-list">' + nodes.map(function (n) {
      var label = '<span class="s-name">' + F.esc(n.name) + '</span>' + nodeMeta(n);
      if (n.container && n.children && n.children.length) {
        return '<details class="s-node" data-offset="' + n.offset + '"' + (n.depth < 1 ? ' open' : '') + '><summary>' + label + '</summary>' + treeHtml(n.children) + '</details>';
      }
      return '<div class="s-leaf" tabindex="-1" data-offset="' + n.offset + '">' + label + '</div>';
    }).join('') + '</div>';
  }

  function setFile(f) { file = f; if (els.tree) { els.tree.innerHTML = ''; setStatus('', false); els.btn.disabled = false; } }
  function reset() { setFile(null); }

  function init() {
    els.panel = $('structure'); els.btn = $('btnStructure'); els.status = $('structStatus'); els.tree = $('structTree');
    if (!els.btn) return;
    els.btn.addEventListener('click', run);
  }

  window.Structure = { setFile: setFile, reset: reset, reveal: reveal,
    onResult: function (fn) { listeners.push(fn); } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
